import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
//? English Version
import addLockInstruction1 from "../../assets/img/tutorialimages/registerLockGuide1.png";
import addLockInstruction2 from "../../assets/img/tutorialimages/registerLockGuide2.png";
import addLockInstruction3 from "../../assets/img/tutorialimages/registerLockGuide3.png";
//? Japanese Version
import addLockInstruction1Jap from "../../assets/img/tutorialimages/registerLockGuide1_Jap.png";
import addLockInstruction2Jap from "../../assets/img/tutorialimages/registerLockGuide2_Jap.png";
import addLockInstruction3Jap from "../../assets/img/tutorialimages/registerLockGuide3_Jap.png";

class RegisterLockGuide extends Component {
  componentWillMount() {
    //! FOR LANGUAGE SETTINGS
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={addLockInstruction1}
            alt="addLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addLockInstruction2}
            alt="addLockInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addLockInstruction3}
            alt="addLockInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.currentLanguage === "ja") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={addLockInstruction1Jap}
            alt="addLockInstruction1Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addLockInstruction2Jap}
            alt="addLockInstruction2Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addLockInstruction3Jap}
            alt="addLockInstruction3Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.currentLanguage === "es") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={addLockInstruction1}
            alt="addLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addLockInstruction2}
            alt="addLockInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addLockInstruction3}
            alt="addLockInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    }
  }
}

export default RegisterLockGuide;
